import { toggleBackgroundScroll } from "@common/utilities";

export const UPDATE_COMMENT = "WH_UPDATE_COMMENT";
export const SELECT_RISK = "WH_SELECT_RISK";
export const TOGGLE_DIALOG = "WH_TOGGLE_DIALOG";
export const TOGGLE_APPENDIX_TIP = "WH_TOGGLE_APPENDIX_TIP";
export const UPSERT_SUGGESTED_TIP = "WH_UPSERT_SUGGESTED_TIP";
export const DELETE_SUGGESTED_TIP = "WH_DELETE_SUGGESTED_TIP";
export const TOGGLE_SUGGESTED_TIP = "WH_TOGGLE_SUGGESTED_TIP";

// Return an action to update the current section comment
const updateComment = (newComment, subSectionIdx) => {
  return {
    type: UPDATE_COMMENT,
    newComment,
    subSectionIdx
  };
};

// Return an action to update a risk indicator
const selectRisk = (isRisk, subSectionIdx, riskIdx) => {
  return {
    type: SELECT_RISK,
    isRisk,
    subSectionIdx,
    riskIdx
  };
};

// Toggle a dialog display
const toggleDialog = (dialog, isShown) => {
  toggleBackgroundScroll(isShown);

  return {
    type: TOGGLE_DIALOG,
    dialog,
    isShown
  };
};

// Upsert a suggested tip
const upsertSuggestedTip = tipInfo => {
  return {
    type: UPSERT_SUGGESTED_TIP,
    tipInfo
  };
};

// Delete a suggested tip
const deleteSuggestedTip = tipInfo => {
  return {
    type: DELETE_SUGGESTED_TIP,
    tipInfo
  };
};

// Toggle a suggested tip
const toggleSuggestedTip = tipInfo => {
  return {
    type: TOGGLE_SUGGESTED_TIP,
    tipInfo
  };
};

// Toggle a risk-specific tip
const toggleAppendixTip = tipInfo => {
  return {
    type: TOGGLE_APPENDIX_TIP,
    tipInfo
  };
};

export {
  updateComment,
  selectRisk,
  toggleDialog,
  upsertSuggestedTip,
  deleteSuggestedTip,
  toggleSuggestedTip,
  toggleAppendixTip
};



// WEBPACK FOOTER //
// ./src/workerhome/components/App/actions.js